import React from "react";
import CourseCard from "./CourseCard";
import { courseType } from "../@types/course";

const CourseCardsContainer = ({ courses }: { courses: courseType[] }) => {
  return (
    <div className="flex items-center justify-center flex-wrap gap-5">
      {courses.length > 0 ? (
        courses.map((course: courseType) => (
          <CourseCard key={course.code} course={course} />
        ))
      ) : (
        <div className="text-center text-gray-500">No courses available</div>
      )}
    </div>
  );
};

export default CourseCardsContainer;
